import { BASE_API } from "../utils/constants";
import { authHeader } from "./token";

// Propinas (fase 2): reparto en la Caja, regla de reparto y saldos por pagar.
async function request(path, token, options = {}) {
  const response = await fetch(`${BASE_API}/api/${path}`, {
    ...options,
    headers: {
      ...authHeader(token),
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const first = result?.detail || Object.values(result || {})[0];
    throw new Error((Array.isArray(first) ? first[0] : first) || "Error en propinas");
  }
  return result;
}

const post = (body) => ({ method: "POST", body: JSON.stringify(body) });

export const getSessionTipsApi = (sessionId, token) =>
  request(`cash-sessions/${sessionId}/tips/`, token);
export const previewTipsApi = (sessionId, participants, token) =>
  request(`cash-sessions/${sessionId}/tips-preview/`, token, post({ participants }));
export const settleTipsApi = (sessionId, participants, token) =>
  request(`cash-sessions/${sessionId}/tips-settle/`, token, post({ participants }));
export const voidTipsApi = (sessionId, settlement, reason, token) =>
  request(`cash-sessions/${sessionId}/tips-void/`, token, post({ settlement, reason }));

export const getTipSettlementsApi = (params, token) =>
  request(`tip-settlements/?${new URLSearchParams(params).toString()}`, token);

export const getTipConfigApi = (token) => request("tip-config/", token);
export const updateTipConfigApi = (data, token) =>
  request("tip-config/", token, { method: "PATCH", body: JSON.stringify(data) });

export const getTipSharesApi = (pending, token) =>
  request(`tip-shares/${pending ? "?pending=1" : ""}`, token);
export const markTipSharePaidApi = (id, note, token) =>
  request(`tip-shares/${id}/mark-paid/`, token, post({ note }));
